(function bookingEngineWidgetLoader() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__GC_BE_WIDGET_LOADER__) return;
  window.__GC_BE_WIDGET_LOADER__ = true;

  const script = document.currentScript;
  if (!script || !(script instanceof HTMLScriptElement)) {
    return;
  }

  const scriptUrl = script.src
    ? new URL(script.src, window.location.href)
    : null;
  const appOrigin = scriptUrl ? scriptUrl.origin : window.location.origin;

  const dataset = script.dataset || {};
  const apiKey = dataset.apiKey || dataset.apikey || '';
  const channelKey = dataset.channelKey || dataset.channelkey || '';
  const defaultAgentChannelKey =
    import.meta.env.VITE_DEFAULT_AGENT_CHANNEL_KEY || '';
  const effectiveChannelKey = channelKey || defaultAgentChannelKey;

  function normalizeApiBase(raw) {
    const s = String(raw || '').trim();
    if (!s) return '';
    return s.endsWith('/') ? s : `${s}/`;
  }

  const API_BASE = normalizeApiBase(
    dataset.apiBase ||
      dataset.apiUrl ||
      dataset.apiURL ||
      import.meta.env.VITE_API_URL ||
      '',
  );
  const HOST_CSS_LINK_ID = 'gc-be-widget-host-custom-css';

  const positionRaw = (dataset.position || 'bottom-right').toLowerCase();
  const width = dataset.width || '400';
  const zIndex = Number(dataset.zIndex || dataset.zindex || 999999);
  const startOpen = dataset.startOpen === '1' || dataset.startOpen === 'true';

  if (!apiKey) {
    console.warn(
      '[Widget] Missing required data-api-key on widget.js script tag.',
    );
    return;
  }

  const API_KEY_PARAM_LOADER = 'apikey';
  const API_KEY_PARAM_IFRAME = import.meta.env.VITE_APIKEY_PARAM_NAME;

  function parsePosition(raw) {
    const parts = String(raw || '')
      .split(/[\s,_-]+/)
      .filter(Boolean);
    let vertical = 'bottom';
    let horizontal = 'right';
    for (const p of parts) {
      if (p === 'top' || p === 'bottom') vertical = p;
      if (p === 'left' || p === 'right') horizontal = p;
    }

    if (raw === 'left' || raw === 'right') horizontal = raw;
    if (raw === 'top' || raw === 'bottom') vertical = raw;
    return { vertical, horizontal };
  }

  const position = parsePosition(positionRaw);

  function injectStylesOnce() {
    if (document.getElementById('gc-be-widget-loader-styles')) return;
    const style = document.createElement('style');
    style.id = 'gc-be-widget-loader-styles';
    style.type = 'text/css';
    style.textContent = `
      .gc-be-widget-loader{ position:fixed; z-index:${zIndex}; }
      .gc-be-widget-loader.gc-be-widget-loader--right{ right:20px; }
      .gc-be-widget-loader.gc-be-widget-loader--left{ left:20px; }
      .gc-be-widget-loader.gc-be-widget-loader--bottom{ bottom:20px; }
      .gc-be-widget-loader.gc-be-widget-loader--top{ top:20px; }

      .gc-be-widget-launcher{ display:flex; align-items:center; justify-content:center; }

      /* Melissa button styles */
      /* Melissa — animated AI assistant button (48×48). Pure CSS. */
      .melissa-btn {
        --ml-duration: 22.4s;
        width: 48px; height: 48px; padding: 0; border: 0; background: none; cursor: pointer;
        display: inline-flex; align-items: center; justify-content: center; flex: none;
      }
      .melissa-btn:focus-visible { outline: 2px solid var(--agentic-fill-gradient-top, #0a7df0); outline-offset: 2px; border-radius: 8px; }

      .ml-icon { position: relative; width: 38.4px; height: 48px; container-type: size; flex: none; }
      .ml-icon * { position: absolute; }
      .ml-grad { background: linear-gradient(135deg, var(--agentic-fill-gradient-top, #0a7df0) 0%, var(--agentic-fill-gradient-bottom, #b30cf0) 100%); }
      .ml-mask-outer, .ml-mask-inner { inset: 0; -webkit-mask-size: 100% 100%; mask-size: 100% 100%; -webkit-mask-repeat: no-repeat; mask-repeat: no-repeat; }
      .ml-mask-outer { -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' preserveAspectRatio='none'%3E%3Cpath d='M20 0H80A20 20 0 0 1 100 20V80A20 20 0 0 1 80 100L80.5 124.5L50 100H20A20 20 0 0 1 0 80V20A20 20 0 0 1 20 0Z'/%3E%3C/svg%3E"); mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' preserveAspectRatio='none'%3E%3Cpath d='M20 0H80A20 20 0 0 1 100 20V80A20 20 0 0 1 80 100L80.5 124.5L50 100H20A20 20 0 0 1 0 80V20A20 20 0 0 1 20 0Z'/%3E%3C/svg%3E"); }
      .ml-mask-inner { -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' preserveAspectRatio='none'%3E%3Cpath d='M20 7H80A13 13 0 0 1 93 20V80A13 13 0 0 1 80 93H72.5L73 109.5L53 93H20A13 13 0 0 1 7 80V20A13 13 0 0 1 20 7Z'/%3E%3C/svg%3E"); mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' preserveAspectRatio='none'%3E%3Cpath d='M20 7H80A13 13 0 0 1 93 20V80A13 13 0 0 1 80 93H72.5L73 109.5L53 93H20A13 13 0 0 1 7 80V20A13 13 0 0 1 20 7Z'/%3E%3C/svg%3E"); }
      .ml-ball { background: var(--agentic-color-ball, #ffffff); }
      .ml-area { top: 0; left: 0; width: 100%; height: 80%; }

      .ml-line { left: 21%; width: 58%; height: 9%; border-radius: 4.5cqw; transform-origin: left center; transform: scaleX(0);
        background: linear-gradient(90deg, var(--agentic-fill-gradient-top, #0a7df0), var(--agentic-fill-gradient-bottom, #b30cf0));
        animation: var(--ml-duration) cubic-bezier(.65,0,.35,1) infinite; }
      .ml-line-1 { top: 66.5%; animation-name: ml-l1; }
      .ml-line-2 { top: 44.5%; animation-name: ml-l2; }
      .ml-line-3 { top: 22.5%; animation-name: ml-l3; }

      .ml-fill { opacity: 0; animation: ml-fill var(--ml-duration) cubic-bezier(.65,0,.35,1) infinite; }
      .ml-dot-wrap { overflow: hidden; }
      .ml-dot { left: 50%; top: 40%; width: 23.5cqw; height: 23.5cqw; border-radius: 50%; transform: translate(-50%,-50%) scale(0);
        animation: ml-dot var(--ml-duration) cubic-bezier(.65,0,.35,1) infinite; }

      /* M dots: X and Y animated on separate layers for curved, fluid paths */
      .ml-mx { left: 50%; top: 50%; width: 0; height: 0; animation: ml-mx var(--ml-duration) cubic-bezier(.45,0,.55,1) infinite; animation-delay: calc(var(--ml-duration) * var(--delay)); }
      .ml-my { left: 0; top: 0; width: 0; height: 0; animation: ml-my var(--ml-duration) cubic-bezier(.45,0,.55,1) infinite; animation-delay: calc(var(--ml-duration) * var(--delay)); }
      .ml-m  { left: -11.75cqw; top: -11.75cqw; width: 23.5cqw; height: 23.5cqw; border-radius: 50%; opacity: 0; animation: ml-mo var(--ml-duration) linear infinite; animation-delay: calc(var(--ml-duration) * var(--delay)); }
      .ml-mx:nth-child(1) { --x: -16cqw; --y: -19cqw; --ax: 16cqw; --ay: 20cqw; --delay: 0; }
      .ml-mx:nth-child(2) { --x: 16.5cqw; --y: -19cqw; --ax: -22cqw; --ay: 14cqw; --delay: 0.0268; }
      .ml-mx:nth-child(3) { --x: -32cqw; --y: 13.5cqw; --ax: 10cqw; --ay: -26cqw; --delay: 0.0118; }
      .ml-mx:nth-child(4) { --x: 0.5cqw; --y: 14cqw; --ax: -26cqw; --ay: -18cqw; --delay: 0.0364; }
      .ml-mx:nth-child(5) { --x: 33cqw; --y: 13.5cqw; --ax: -8cqw; --ay: 26cqw; --delay: 0.0192; }


      /* Hover: white and gradient swap (cross-faded) */
      .ml-ball::before, .ml-grad::before, .ml-line::before {
        content: ""; position: absolute; inset: 0; border-radius: inherit; opacity: 0;
        transition: opacity .3s ease;
      }
      .ml-ball::before { background: linear-gradient(135deg, var(--agentic-fill-gradient-top, #0a7df0) 0%, var(--agentic-fill-gradient-bottom, #b30cf0) 100%); }
      .ml-grad::before, .ml-line::before { background: var(--agentic-color-ball, #ffffff); }
      .melissa-btn:hover .ml-icon ::before, .melissa-btn:focus-visible .ml-icon ::before { opacity: 1; }

      /* Chat-bubble border always stays gradient (ring drawn on top) */
      .ml-icon::after {
        content: ""; position: absolute; inset: 0; opacity: 0; transition: opacity .3s ease; pointer-events: none;
        background: linear-gradient(135deg, var(--agentic-fill-gradient-top, #0a7df0) 0%, var(--agentic-fill-gradient-bottom, #b30cf0) 100%);
        -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' preserveAspectRatio='none'%3E%3Cpath d='M20 0H80A20 20 0 0 1 100 20V80A20 20 0 0 1 80 100L80.5 124.5L50 100H20A20 20 0 0 1 0 80V20A20 20 0 0 1 20 0Z'/%3E%3C/svg%3E"), url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' preserveAspectRatio='none'%3E%3Cpath d='M20 7H80A13 13 0 0 1 93 20V80A13 13 0 0 1 80 93H72.5L73 109.5L53 93H20A13 13 0 0 1 7 80V20A13 13 0 0 1 20 7Z'/%3E%3C/svg%3E"); mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' preserveAspectRatio='none'%3E%3Cpath d='M20 0H80A20 20 0 0 1 100 20V80A20 20 0 0 1 80 100L80.5 124.5L50 100H20A20 20 0 0 1 0 80V20A20 20 0 0 1 20 0Z'/%3E%3C/svg%3E"), url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' preserveAspectRatio='none'%3E%3Cpath d='M20 7H80A13 13 0 0 1 93 20V80A13 13 0 0 1 80 93H72.5L73 109.5L53 93H20A13 13 0 0 1 7 80V20A13 13 0 0 1 20 7Z'/%3E%3C/svg%3E");
        -webkit-mask-size: 100% 100%; mask-size: 100% 100%; -webkit-mask-repeat: no-repeat; mask-repeat: no-repeat;
        -webkit-mask-composite: xor; mask-composite: exclude;
      }
      .melissa-btn:hover .ml-icon::after, .melissa-btn:focus-visible .ml-icon::after { opacity: 1; }

      @media (prefers-reduced-motion: reduce) {
        .ml-icon *, .ml-icon *::before { animation-play-state: paused !important; }
      }

      @keyframes ml-l1{0%,3.208%{transform:scaleX(0);opacity:1;top:66.5%;left:21%;width:58%;height:9%;border-radius:4.5cqw}6.417%,41.711%{transform:scaleX(1);opacity:1;top:66.5%;left:21%;width:58%;height:9%;border-radius:4.5cqw}44.92%{transform:scaleX(1);opacity:1;top:59.5%;left:20%;width:60%;height:20.5%;border-radius:1cqw}44.925%,100%{opacity:0}}
      @keyframes ml-l2{0%,7.486%{transform:scaleX(0);opacity:1;top:44.5%;left:21%;width:58%;height:9%;border-radius:4.5cqw}10.695%,41.711%{transform:scaleX(1);opacity:1;top:44.5%;left:21%;width:58%;height:9%;border-radius:4.5cqw}44.92%{transform:scaleX(1);opacity:1;top:39.8%;left:20%;width:60%;height:20.5%;border-radius:0}44.925%,100%{opacity:0}}
      @keyframes ml-l3{0%,11.765%{transform:scaleX(0);opacity:1;top:22.5%;left:21%;width:58%;height:9%;border-radius:4.5cqw}14.973%,41.711%{transform:scaleX(1);opacity:1;top:22.5%;left:21%;width:58%;height:9%;border-radius:4.5cqw}44.92%{transform:scaleX(1);opacity:1;top:20%;left:20%;width:60%;height:20.5%;border-radius:1cqw}44.925%,100%{opacity:0}}
      @keyframes ml-fill{0%,44.914%{opacity:0;clip-path:inset(16% 20% 36% 20% round 1cqw)}44.92%{opacity:1;clip-path:inset(16% 20% 36% 20% round 1cqw)}49.198%,100%{opacity:1;clip-path:inset(0% 0% 0% 0% round 0cqw)}}
      @keyframes ml-dot{0%,49.732%{opacity:1;transform:translate(-50%,-50%) scale(0)}51.337%{transform:translate(-50%,-50%) scale(1.25)}52.941%,53.476%{opacity:1;transform:translate(-50%,-50%) scale(1)}53.481%,92.781%{opacity:0;transform:translate(-50%,-50%) scale(1)}92.786%{opacity:1;transform:translate(-50%,-50%) scale(1);animation-timing-function:cubic-bezier(.55,0,.8,.4)}97.861%,100%{opacity:1;transform:translate(-50%,-50%) scale(6.2)}}
      @keyframes ml-mo{0%,52.941%{opacity:0}52.947%,95.722%{opacity:1}95.727%,100%{opacity:0}}
      @keyframes ml-mx{0%,53.476%{transform:translateX(0)}56.15%{transform:translateX(var(--ax));animation-timing-function:cubic-bezier(.3,0,.15,1)}62.567%,89.305%{transform:translateX(var(--x))}92.781%,100%{transform:translateX(0)}}
      @keyframes ml-my{0%,53.476%{transform:translateY(0)}57.486%{transform:translateY(var(--ay));animation-timing-function:cubic-bezier(.3,0,.15,1)}62.567%,89.305%{transform:translateY(var(--y))}92.781%,100%{transform:translateY(0)}}

      .gc-be-widget-layer{
        position:fixed;
        top:0;
        left:0;
        width:100vw;
        height:100vh;
        margin:0;
        padding:0;
        border:0;
        transition:opacity 200ms ease, transform 200ms ease;
      }
      .gc-be-widget-overlay{
        position:fixed;
        inset:0;
        background:rgba(0,0,0,0.35);
        backdrop-filter: blur(2px);
      }
      .gc-be-widget-panel{
        position:fixed;
        border-radius:12px;
        overflow:hidden;
        box-shadow:0 18px 60px rgba(0,0,0,0.35);
        background:#fff;
      }
      /* Overlay + panel live inside .gc-be-widget-layer; absolute so they move with the layer (no fixed-to-viewport bleed when hidden). */
      .gc-be-widget-layer .gc-be-widget-overlay{
        position:absolute;
        inset:0;
        z-index:0;
      }
      .gc-be-widget-layer .gc-be-widget-panel{
        position:absolute;
        z-index:1;
      }
      .gc-be-widget-panel iframe{
        display:block;
        width:100%;
        height:100%;
        border:0;
      }
      @media (max-width:639px){
        .gc-be-widget-panel{
          top:48px !important;
          left:0 !important;
          right:0 !important;
          bottom:0 !important;
          width:100% !important;
          height:calc(100% - 48px) !important;
          border-radius:12px 12px 0 0 !important;
          box-shadow:0 -4px 24px rgba(0,0,0,0.2) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function buildIframeUrl() {
    const url = new URL('/agent', appOrigin);
    url.searchParams.set(API_KEY_PARAM_IFRAME, apiKey);
    if (effectiveChannelKey) {
      url.searchParams.set('channelKey', effectiveChannelKey);
    }
    url.searchParams.set('iframeMode', '1');
    url.searchParams.set('widgetMode', '1');

    try {
      url.searchParams.set('referrer', window.location.hostname || '');
      url.searchParams.set('url', window.location.href || '');
    } catch {
      // Ensure the catch isn't optimized into an empty block in minified builds
      url.searchParams.delete('referrer');
      url.searchParams.delete('url');
    }
    return url.toString();
  }

  function buildAuthQueryString(extra) {
    const p = new URLSearchParams();
    p.set(API_KEY_PARAM_LOADER, apiKey);
    if (effectiveChannelKey) {
      p.set('channelKey', effectiveChannelKey);
    }
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach((k) => {
        const v = extra[k];
        if (v != null && v !== '') {
          p.set(k, String(v));
        }
      });
    }
    return p.toString();
  }

  function applyHostCssOverride(hotelId, hotelTemplateCss) {
    const existing = document.getElementById(HOST_CSS_LINK_ID);
    if (existing) {
      existing.remove();
    }
    let href = null;
    if (hotelTemplateCss) {
      href = hotelTemplateCss;
    }
    if (!href) {
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = href;
    link.id = HOST_CSS_LINK_ID;
    document.head.appendChild(link);
  }

  async function fetchBearerToken() {
    const url = `${API_BASE}hola?${buildAuthQueryString()}`;
    const res = await fetch(url, { method: 'GET', credentials: 'omit' });
    if (!res.ok) {
      return null;
    }
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) {
      const j = await res.json();
      if (typeof j === 'string') {
        return j;
      }
      if (j && typeof j === 'object') {
        return j.token ?? j.data ?? j.access_token ?? null;
      }
    }
    const text = (await res.text()).trim();
    if (text.startsWith('"') && text.endsWith('"')) {
      try {
        return JSON.parse(text);
      } catch {
        return text.replace(/^"|"$/g, '');
      }
    }
    return text || null;
  }

  async function fetchSetupJson(bearer) {
    const url = `${API_BASE}setup?${buildAuthQueryString()}`;
    const res = await fetch(url, {
      method: 'GET',
      credentials: 'omit',
      headers: {
        Authorization: `Bearer ${bearer}`,
      },
    });
    if (!res.ok) {
      throw new Error(`setup failed: ${res.status}`);
    }
    return res.json();
  }

  function startHostSetupPreload({ onAgentActive, onSetup } = {}) {
    if (!API_BASE) {
      try {
        onAgentActive && onAgentActive(true);
      } catch {
        // ignore
      }
      return;
    }
    (async () => {
      try {
        const token = await fetchBearerToken();
        if (!token) {
          try {
            onAgentActive && onAgentActive(true);
          } catch {
            // ignore
          }
          return;
        }
        const data = await fetchSetupJson(token);
        try {
          onSetup && onSetup(data);
        } catch {
          // ignore
        }
        const hotelId = data && data.hotel_id;
        const hotelTemplateCss = data && data.hotel_template_css;
        applyHostCssOverride(hotelId, hotelTemplateCss);
        const agentActive =
          data?.booking_engine_agent?.active == null
            ? true
            : data.booking_engine_agent.active !== false;
        try {
          onAgentActive && onAgentActive(agentActive);
        } catch {
          // ignore
        }
      } catch (e) {
        console.warn('[Widget] Host setup / CSS preload failed:', e);
        try {
          onAgentActive && onAgentActive(true);
        } catch {
          // ignore
        }
      }
    })();
  }

  function clampNumber(val, fallback) {
    const n = Number(val);
    return Number.isFinite(n) ? n : fallback;
  }

  function createLauncher() {
    const root = document.createElement('div');
    root.className = `gc-be-widget-loader gc-be-widget-loader--${position.vertical} gc-be-widget-loader--${position.horizontal}`;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'melissa-btn';
    btn.setAttribute('aria-label', 'Open booking widget');
    btn.innerHTML = `
      <span class="ml-icon" aria-hidden="true">
        <span class="ml-grad ml-mask-outer"></span>
        <span class="ml-ball ml-mask-inner"></span>
        <span class="ml-area">
          <span class="ml-line ml-line-1"></span>
          <span class="ml-line ml-line-2"></span>
          <span class="ml-line ml-line-3"></span>
        </span>
        <span class="ml-fill ml-grad ml-mask-outer"></span>
        <span class="ml-dot-wrap ml-mask-inner"><span class="ml-dot ml-ball"></span></span>
        <span class="ml-area">
          <span class="ml-mx"><span class="ml-my"><span class="ml-m ml-ball"></span></span></span>
          <span class="ml-mx"><span class="ml-my"><span class="ml-m ml-ball"></span></span></span>
          <span class="ml-mx"><span class="ml-my"><span class="ml-m ml-ball"></span></span></span>
          <span class="ml-mx"><span class="ml-my"><span class="ml-m ml-ball"></span></span></span>
          <span class="ml-mx"><span class="ml-my"><span class="ml-m ml-ball"></span></span></span>
        </span>
      </span>`;

    root.appendChild(btn);
    return { root, btn };
  }

  function runWhenBodyReady(fn) {
    if (document.body) {
      fn();
      return;
    }

    const tryStart = () => {
      if (!document.body) return;
      fn();
    };

    document.addEventListener('DOMContentLoaded', tryStart, { once: true });

    let attempts = 0;
    const maxAttempts = 200; // ~10s at 50ms
    const intervalId = window.setInterval(() => {
      attempts += 1;
      if (document.body) {
        window.clearInterval(intervalId);
        tryStart();
        return;
      }
      if (attempts >= maxAttempts) {
        window.clearInterval(intervalId);
      }
    }, 50);
  }

  function init() {
    // If some other script removed body, just bail quietly.
    if (!document.body) return;

    injectStylesOnce();

    const { root, btn } = createLauncher();
    // Start hidden until setup confirms the agent is active.
    root.style.display = 'none';
    document.body.appendChild(root);

    const layerEl = document.createElement('div');
    layerEl.id = 'gc-be-widget-layer';
    layerEl.className = 'gc-be-widget-layer';
    layerEl.setAttribute('aria-hidden', 'true');

    const overlayEl = document.createElement('div');
    overlayEl.className = 'gc-be-widget-overlay';

    const panelEl = document.createElement('div');
    panelEl.className = 'gc-be-widget-panel';

    const iframeEl = document.createElement('iframe');
    iframeEl.src = buildIframeUrl();
    iframeEl.loading = 'eager';
    iframeEl.setAttribute('aria-hidden', 'true');
    iframeEl.tabIndex = -1;
    iframeEl.title = 'Booking widget';
    iframeEl.allow = 'payment *; clipboard-write *';
    iframeEl.referrerPolicy = 'strict-origin-when-cross-origin';
    // Ensure iframe content can always scroll when constrained.
    iframeEl.setAttribute('scrolling', 'yes');
    iframeEl.style.cssText =
      'display:block;width:100%;height:100%;border:0;overflow:auto;';

    panelEl.appendChild(iframeEl);
    layerEl.appendChild(overlayEl);
    layerEl.appendChild(panelEl);

    let isOpen = false;
    let canOpen = true;

    startHostSetupPreload({
      onAgentActive: (active) => {
        canOpen = active !== false;
        root.style.display = canOpen ? '' : 'none';
        if (!canOpen) {
          close();
        }
      },
    });

    function setLayerClosedStyle() {
      layerEl.setAttribute('aria-hidden', 'true');
      layerEl.style.cssText = [
        'position:fixed',
        'top:0',
        'left:0',
        'width:100vw',
        'height:100vh',
        'opacity:0',
        'pointer-events:none',
        'transform:scale(0.98)',
        `z-index:${zIndex}`,
      ].join(';');
    }

    function setLayerOpenStyle() {
      layerEl.setAttribute('aria-hidden', 'false');
      layerEl.style.left = '0';
      layerEl.style.opacity = '1';
      layerEl.style.pointerEvents = 'auto';
      layerEl.style.transform = 'scale(1)';
    }

    setLayerClosedStyle();
    document.body.appendChild(layerEl);

    function isMobile() {
      return window.innerWidth < 640;
    }

    function layoutPanel() {
      if (isMobile()) {
        const mobileTop = 48;
        panelEl.style.inset = '';
        panelEl.style.top = `${mobileTop}px`;
        panelEl.style.left = '0';
        panelEl.style.right = '0';
        panelEl.style.bottom = '0';
        panelEl.style.width = '100%';
        panelEl.style.height = `calc(100% - ${mobileTop}px)`;
        panelEl.style.borderRadius = '12px 12px 0 0';
        panelEl.style.boxShadow = '0 -4px 24px rgba(0,0,0,0.2)';
        return;
      }

      const margin = 20;
      const isLeft = position.horizontal === 'left';
      const fixedWidth = clampNumber(width, 400);

      // Desktop/tablet:
      // - 20px margin to viewport edges (top/bottom always 20px)
      // - fixed width (default 400px, configurable via data-width)
      // - height always tracks viewport height (no minimum height clamping)
      panelEl.style.inset = '';
      panelEl.style.top = `${margin}px`;
      panelEl.style.bottom = `${margin}px`;
      panelEl.style.borderRadius = '12px';
      panelEl.style.boxShadow = '0 18px 60px rgba(0,0,0,0.35)';
      panelEl.style.minWidth = '';
      panelEl.style.minHeight = '';
      panelEl.style.width = `${fixedWidth}px`;
      panelEl.style.height = '';
      panelEl.style[isLeft ? 'left' : 'right'] = `${margin}px`;
      panelEl.style[isLeft ? 'right' : 'left'] = '';
    }

    function open() {
      if (isOpen) return;
      if (!document.body) return;
      if (!canOpen) return;
      isOpen = true;
      setLayerOpenStyle();
      layoutPanel();
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      setLayerClosedStyle();
    }

    function toggle() {
      if (isOpen) close();
      else open();
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') close();
    }

    overlayEl.addEventListener('click', close);
    document.addEventListener('keydown', onKeyDown);

    layoutPanel();

    btn.addEventListener('click', toggle);
    window.addEventListener('resize', layoutPanel);

    window.addEventListener('message', (event) => {
      // Only accept messages from the iframe app origin
      if (event.origin !== appOrigin) return;
      const data = event.data;
      if (data && typeof data === 'object') {
        if (data.type === 'close') {
          close();
        }
        if (data.type === 'reload-host') {
          close();
          window.location.reload();
        }
      }
    });

    if (startOpen) open();

    // Expose a minimal debug API (not part of public contract)
    window.__GC_BE_WIDGET__ = {
      open,
      close,
      toggle,
      destroy() {
        close();
        document.removeEventListener('keydown', onKeyDown);
        window.removeEventListener('resize', layoutPanel);
        btn.removeEventListener('click', toggle);
        if (layerEl && layerEl.parentNode) {
          layerEl.remove();
        }
        const hostCss = document.getElementById(HOST_CSS_LINK_ID);
        if (hostCss) {
          hostCss.remove();
        }
        root.remove();
      },
    };
  }

  runWhenBodyReady(init);
})();
